export const NODE_ENV = "development";
export const NODE_WALLET_BACK = "https://api.caribmall.com";
//export const NODE_WALLET_BACK = "http://localhost:8000";
export const EXPRESS = 'https://api-payment.globalunbanked.com';
export const MERCHANT_KEY = 'd2222558-bbbe-11ee-a157-9d7297eb2329';